import React, {Component} from 'react';
import MathJax from 'react-mathjax'

class LatexViewComponent extends Component {
    constructor(props){
        super(props)

        this.state = {

        }
    }

    componentDidMount(){
        this.setState({
            text: this.props.text
        })
    }

    /*shouldComponentUpdate(nextProps, nextState){
        if(this.state.text != nextProps.text){
            console.log('updating')
            return true
        }

        return false
    }*/

    render(){
        return(
            <div className = {!this.props.NoBorder ? "border border-info" : ""} style = {{width:this.props.width || '100%', height:this.props.height || '100%', flexDirection:'column', display: 'flex', alignItems:'center', justifyContent:'center' }}>
                <MathJax.Provider>
                    <MathJax.Node formula={this.props.text} />
                </MathJax.Provider>
            </div>
        )
    }
}

export default LatexViewComponent